import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  BrandXS,
  HeadlineL,
  TypographyVariant,
} from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';

const StyledSpan = styled.span`
  display: inline-flex;
  gap: 2px;
  align-items: start;
  font-family: var(--brand-font);
`;
const Exposant = styled(BrandXS)`
  color: var(--c-nd-600);
  margin-top: var(--half-unit);
`;

type Props = {
  score: number | null;
  Typography?: TypographyVariant;
};

export const ContenderScore = ({ score, Typography = HeadlineL }: Props) => {
  return (
    <Typography>
      <StyledSpan>
        <FormattedMessage
          {...fantasy.ordinalPoints}
          values={{
            score: typeof score === 'number' ? Math.floor(score || 0) : '-',
            sup: c => <Exposant>{c}</Exposant>,
          }}
        />
      </StyledSpan>
    </Typography>
  );
};
